import { createPlugin } from '@backstage/core-plugin-api';

import { createResourceLinkExtension } from '@spotify/confidence-core-react';

import { IdentityResourceLink } from './components';

export const eventsPlugin = createPlugin({
  id: 'confidence-iam',
});

export const IdentityResourceLinkExtension = eventsPlugin.provide(
  createResourceLinkExtension({
    id: 'identity-resource-link',
    predicate: ({ name }) => name.startsWith('identities/'),
    render: ({ name, text }) => (
      <IdentityResourceLink name={name} text={text} />
    ),
  }),
);
